import React from 'react';
import { Loading, Text } from '@cko/primitives';
import styled from 'styled-components';
export const PAGE_LOADER_TEST_ID = 'page-loader';
const LoadingViewContent = styled.div `
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
`;
export const PageLoader = () => {
    return (React.createElement(LoadingViewContent, { "data-testid": PAGE_LOADER_TEST_ID },
        React.createElement(Loading, { width: "50px" }),
        React.createElement(Text, null, "Loading")));
};
